module.exports = __webpack_public_path__ + "img/full1-min.fcd42f20.png";